module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/products/products.component.scss
// module id = ./src/app/routes/products/products.component.scss
// module chunks = 9